import { useEffect } from "react";

export function useUpdateParam(
  param: string,
  value: string | null | undefined
) {
  useEffect(() => {
    // undefined means "don't touch the URL" - skip update entirely
    // This is useful during loading states when we don't want to remove existing values
    if (value === undefined) {
      return;
    }

    // Get current search params directly from window instead of useSearchParams()
    const currentSearchParams = new URLSearchParams(window.location.search);
    const currentValue = currentSearchParams.get(param);

    if (value) {
      if (currentValue !== value) {
        currentSearchParams.set(param, value);
      }
    } else if (currentValue !== null) {
      // value is null - remove the param
      currentSearchParams.delete(param);
    }

    // Only update URL if there were changes
    if (currentValue !== (value || null)) {
      const newUrl = `?${currentSearchParams.toString()}`;
      window.history.replaceState({}, "", window.location.pathname + newUrl);
      // "Silent" tracking write (e.g. searchId). On Next >=14.1 Next patches
      // replaceState, so useSearchParams still updates here — this write is NOT
      // invisible to React. Refetch loops are prevented by excluding these params
      // from the React Query key (getFilterKey), not by withholding any event.
    }
  }, [param, value]);
}
